import React from 'react';
import { TextField, Button, Avatar, Typography, Box, IconButton } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AppContainer from '../components/AppContainer';
import TextContainer from '../components/TextContainer';
// Firebase
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
// Schemas/Validation
import { resetPasswordSchema } from '../validation/schemas';
import { Formik, Form, Field, ErrorMessage } from 'formik';
// React Router Dom
import { useNavigate } from 'react-router-dom';

function ResetPassword() {
    const [loading, setLoading] = React.useState(false);
    const navigate = useNavigate();

    const handleFormSubmit = async (values, { setSubmitting }) => {
        setSubmitting(true);
        const { email } = values;
        const auth = getAuth(); // Initialize Firebase Auth
        try {
            // Send a password reset email
            await sendPasswordResetEmail(auth, email).then(() => {
                console.log("Password reset email sent to: ", email);
                navigate('/reset-password-done');
            });
            
        } catch (error) {
            console.error("Error sending password reset email:", error.message);
            // Optional: display error message to user
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <AppContainer>
        <Formik
            initialValues={{ email: ''}}
            validationSchema={resetPasswordSchema}
            onSubmit={handleFormSubmit}
        >
        {({ isSubmitting, errors, touched }) => (
          <Form>
            <Box style={{ display: 'flex', flexDirection: 'column', minHeight: window.innerHeight, alignItems: 'center' }}>
                <Box sx={{marginTop: '50px', width: '100%'}}>
                    <IconButton color='black' onClick={() => {navigate(-1)}}>
                        <ArrowBackIcon/>
                    </IconButton>
                </Box>
                <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                  <PersonIcon />
                </Avatar>
                <Typography component="h1" variant="h5">Reset Password</Typography>
                <TextContainer>
                    <Field 
                        as={TextField}
                        id='email'
                        name='email'
                        sx={{width: '100%', marginTop: '20px'}} 
                        label="Email Address"
                        variant="filled" 
                        required
                        error={errors.email && touched.email}
                    />
                    <ErrorMessage name="email" component="div" style={{ color: 'red' }} />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                        disabled={loading}
                    >
                        {loading ? "Sending..." : "Send Password Reset Email"}
                    </Button>
                </TextContainer>
            </Box>
          </Form>
        )}
      </Formik>
    </AppContainer>
    )
}

export default ResetPassword